import React, { useEffect, useState } from 'react';

import { InfoPopup } from '../infoPopup/infoPopup';
import { GameHistoryPopup } from '../gameHistoryPopup/gameHistoryPopup';

import { HISTORY_ICON_STATE, INFO_ICON_STATE } from '../../stateManagment';

import './popup.css';

const popupType = {
  history: 'history',
  info: 'info',
};

const popupsByType = {
  [popupType.history]: GameHistoryPopup,
  [popupType.info]: InfoPopup,
};

export const Popup = () => {
  const [state, setState] = useState(null);

  useEffect(() => {
    const historySubscriber = HISTORY_ICON_STATE.subscribe((val) => {
      if (val) {
        setState(popupType.history);
        INFO_ICON_STATE.next(null);
      } else {
        if (!INFO_ICON_STATE.getValue()) {
          setState(null);
        }
      }
    });
    const infoSubscriber = INFO_ICON_STATE.subscribe((val) => {
      if (val) {
        setState(popupType.info);
        HISTORY_ICON_STATE.next(null);
      } else {
        if (!HISTORY_ICON_STATE.getValue()) {
          setState(null);
        }
      }
    });
    return () => {
      historySubscriber.unsubscribe();
      infoSubscriber.unsubscribe();
    };
  }, []);

  const Component = popupsByType[state];

  return !!state && (
    <section className="popup-root">
      <div className="popup-content">
        <Component/>
      </div>
    </section>
  );
};
